import React from "react";

// Phase 12.2 — minimal-glyph role badge that meets AA in both light + dark.
// Each role gets a colored dot indicator; the label text uses --page-fg so
// contrast holds regardless of theme. The dot is tuned to be ≥ 3:1 against the
// pill surface (non-text contrast threshold).
const ROLE_DOT = {
  hr: "#1E3A5F", // navy
  manager: "#3B82F6", // blue
  leadership: "#9A7A2A", // gold (darkened for AA on light pill)
  compliance: "#8B5CF6", // purple
};

const ROLE_LABELS = {
  hr: "HR",
  manager: "Manager",
  leadership: "Leadership",
  compliance: "Compliance",
};

export function RoleBadge({ role }) {
  const dot = ROLE_DOT[role] || "var(--page-fg-muted)";
  return (
    <span
      data-testid="role-badge"
      className="inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-[0.10em]"
      style={{
        backgroundColor: "var(--surface-2)",
        color: "var(--page-fg)",
        boxShadow: "inset 0 0 0 1px var(--border-subtle)",
      }}
    >
      <span
        aria-hidden
        className="inline-block h-1.5 w-1.5 rounded-full"
        style={{ backgroundColor: dot }}
      />
      {ROLE_LABELS[role] || role}
    </span>
  );
}

export default RoleBadge;
